import React from "react";
import { Box } from "@mui/material"

const APIDocs = ({ apiDocs }) => {
  return (
    <Box sx={{ py: 2, height: "459px", overflow: "auto" }}>
      <pre dangerouslySetInnerHTML={{ __html: apiDocs }} style={{ whiteSpace: 'pre-wrap' }} />
      {/* {apiDocs ? apiDocs : "No documentation found!"} */}
    </Box>
  )
}

export default APIDocs;
